import { FC } from 'react';
import { Avatar, useTheme } from '@mui/material';

interface Props {
  avatarText: string;
  asListItem?: boolean;
}

export const AccountPopoverAvatar: FC<Props> = ({ avatarText, asListItem }) => {
  const {
    palette: { mode },
  } = useTheme();

  return (
    <Avatar
      sx={{
        width: '40px',
        height: '40px',
        backgroundColor:
          mode === 'light' ? (asListItem ? '#F9EFE7' : '#FFFFFF') : '#19252C',
        border: asListItem ? '1px solid #815F52' : undefined,
        fontSize: '14px',
        fontWeight: '400',
        color: 'text.primary',
        borderRadius: '3px',
      }}
      variant="rounded">
      {avatarText}
    </Avatar>
  );
};
